/* src/app/pages/new-analysis/new-analysis.component.scss */
.fill-remaining-space {
  flex: 1 1 auto;
}
.container {
  padding: 10px;
  margin: 20px;
}
.form {
  min-width: 150px;
  max-width: 700px;
  width: 100%;
}
.form-element {
  padding: 5px 0px 25px 2px;
  width: 100%;
}
.button {
  margin: 75px 1px;
}
.error {
  font-size: 12px;
}
.text-danger {
  font-size: smaller;
}
::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: white;
}
.matrix-radio-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}
/*# sourceMappingURL=new-analysis.component.css.map */
